var RenderingEngineModeEnum;
(function (RenderingEngineModeEnum) {
    RenderingEngineModeEnum["Tiled"] = "tiled";
    RenderingEngineModeEnum["ContextPool"] = "contextPool";
})(RenderingEngineModeEnum || (RenderingEngineModeEnum = {}));
export default RenderingEngineModeEnum;
